<ng-template let-context let-modal="modal" #modalTemplate class="refresh-popup">
    <div>
        <img class="ui medium image van-img" src={{leasing.picture}}>
        <h3 class="text-center name">{{leasing.name}}</h3>
        <div class="ui stackable two column grid">
            <div class="column">
                <p class="text-center">{{"Places: " + leasing.seats}}</p>
                <p class="text-center">{{"Charge utile: " + leasing.payload + "kg"}}</p>
                <p *ngIf="leasing.volume != 0" class="text-center">{{"Volume utile: " + leasing.volume + "m3"}}</p>
            </div>
            <div class="column">
                <p class="text-center">{{"Longueur: " + leasing.length + "cm"}}</p>
                <p class="text-center">{{"Largeur: " + leasing.width + "cm"}}</p>
                <p class="text-center">{{"Hauteur: " + leasing.height + "cm"}}</p>
            </div>
        </div>
        <div class="margin-bottom-30"></div>
    </div>
    <div class="actions">
        <button class="ui button" (click)="modal.deny('denied')">Ok</button>
    </div>
</ng-template>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/leasing/leasingDetails/leasingDetails.html